import type {
  PdpEddProductSpecs,
  ResolvedExpectedDeliveryDate,
} from '../domain/models/ResolvedExpectedDeliveryDate';
import {
  formatEddDate,
  getCustomizationEddKeyFromSpecs,
  getSameDayMessage,
  isSizeableSkuMap,
} from './eddFormatting';

export function resolveExpectedDeliveryDate(
  designEddDetails: unknown | null,
  productSpecs: PdpEddProductSpecs,
  selectedSize: string | null
): ResolvedExpectedDeliveryDate {
  if (!designEddDetails || typeof designEddDetails !== 'object') {
    return { edd: null, eddFullDate: null, sameDayMessage: null };
  }

  const eddData = designEddDetails as Record<string, unknown>;
  const key = getCustomizationEddKeyFromSpecs(productSpecs);
  const customization = eddData[key] as Record<string, unknown> | undefined;
  if (!customization?.skuCodeMap) {
    return { edd: null, eddFullDate: null, sameDayMessage: null };
  }

  const skuMap = customization.skuCodeMap as Record<string, Record<string, unknown>>;
  const sizeable = isSizeableSkuMap(skuMap);
  const sizeKey = sizeable ? (selectedSize ?? productSpecs.defaultSize ?? '00') : '00';
  const sizeEntry = skuMap[sizeKey];

  if (!sizeEntry?.deliveryDateInfo) {
    return { edd: null, eddFullDate: null, sameDayMessage: null };
  }

  const deliveryDateInfo = sizeEntry.deliveryDateInfo as Record<string, unknown>;
  const expectedDeliveryDate =
    typeof deliveryDateInfo.expectedDeliveryDate === 'string'
      ? deliveryDateInfo.expectedDeliveryDate
      : null;

  if (!expectedDeliveryDate) {
    return { edd: null, eddFullDate: null, sameDayMessage: null };
  }

  return {
    edd: formatEddDate(expectedDeliveryDate),
    eddFullDate: expectedDeliveryDate,
    sameDayMessage: getSameDayMessage(expectedDeliveryDate),
  };
}
